// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"52":"a7f23fee","621":"161f0ae7","817":"402cf01e","962":"1a708cee"}[chunkId] + ".chunk.js";
};